import { ThemeToggle } from "@/components/theme-toggle";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_public/colors")({
	component: RouteComponent,
});

const tokenPairs = [
	["background", "foreground"],
	["card", "card-foreground"],
	["popover", "popover-foreground"],
	["primary", "primary-foreground"],
	["secondary", "secondary-foreground"],
	["muted", "muted-foreground"],
	["accent", "accent-foreground"],
	["sidebar", "sidebar-foreground"],
	["sidebar-primary", "sidebar-primary-foreground"],
	["sidebar-accent", "sidebar-accent-foreground"],
];

const singleTokens = [
	"destructive",
	"border",
	"input",
	"ring",
	"sidebar-border",
	"sidebar-ring",
];

const chartTokens = ["chart-1", "chart-2", "chart-3", "chart-4", "chart-5"];

function RouteComponent() {
	return (
		<div className="grid grid-cols-1 gap-4 p-6 sm:grid-cols-2 md:grid-cols-3">
			<ThemeToggle />
			{tokenPairs.map(([bg, fg]) => (
				<div
					key={bg}
					className="flex items-center justify-center rounded-2xl border p-6 font-semibold shadow"
					style={{
						background: `var(--${bg})`,
						color: `var(--${fg})`,
						borderColor: "var(--border)",
					}}
				>
					{bg} / {fg}
				</div>
			))}

			{singleTokens.map((token) => (
				<div
					key={token}
					className="flex items-center justify-center rounded-2xl border p-6 font-semibold shadow"
					style={{
						background: `var(--${token})`,
						color: "var(--foreground)",
						borderColor: "var(--border)",
					}}
				>
					{token}
				</div>
			))}

			{chartTokens.map((token) => (
				<div
					key={token}
					className="flex items-center justify-center rounded-2xl border p-6 font-semibold shadow"
					style={{
						background: `var(--${token})`,
						color: "var(--foreground)",
						borderColor: "var(--border)",
					}}
				>
					{token}
				</div>
			))}
		</div>
	);
}
